import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noSpecialCharactersValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value || typeof control.value !== 'string') {
      return null;
    }
    const regex = /[!@#$%^&*(),.?":{}|<>]/;
    return regex.test(control.value) ? { specialChars: true } : null;
  };
}